module.exports = __webpack_public_path__ + "static/media/Info.ec464738.svg";